var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/MemberProfileEdit/MemberProfileEditCredits.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/MemberProfileEdit/MemberProfileEditCredits.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
var macro_t_4 = runtime.makeMacro(
[], 
["data"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});var t_5 = "";t_5 += "\n    <div class=\"MemberProfileEditCredits\">\n        <div class=\"MemberProfileEditCredits-body MemberProfileEdit-scrollbox\">\n            <div class=\"MemberProfileEditCredits-body-scrollBlock\">\n                <div class=\"MemberProfileEditCredits-body-scrollBlock-inner\">\n                    <form class=\"MemberProfileEditCredits-body-form\">\n                        ";
frame = frame.push();
var t_8 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"credits");
if(t_8) {t_8 = runtime.fromIterator(t_8);
var t_7 = t_8.length;
for(var t_6=0; t_6 < t_8.length; t_6++) {
var t_9 = t_8[t_6];
frame.set("item", t_9);
frame.set("loop.index", t_6 + 1);
frame.set("loop.index0", t_6);
frame.set("loop.revindex", t_7 - t_6);
frame.set("loop.revindex0", t_7 - t_6 - 1);
frame.set("loop.first", t_6 === 0);
frame.set("loop.last", t_6 === t_7 - 1);
frame.set("loop.length", t_7);
t_5 += "\n                            <div class=\"MemberProfileEditCredits-body-form-inputWrapper\">\n                                <input type=\"hidden\" name=\"id\" value=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),"id"), env.opts.autoescape);
t_5 += "\">\n                                <input type=\"hidden\" name=\"title\" value=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),"title"), env.opts.autoescape);
t_5 += "\">\n                                <input type=\"hidden\" name=\"cover\" value=\"";
t_5 += runtime.suppressValue(env.getFilter("tojson").call(context, runtime.memberLookup((t_9),"cover")), env.opts.autoescape);
t_5 += "\">\n                                <input type=\"hidden\" name=\"url\" value=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),"url"), env.opts.autoescape);
t_5 += "\">\n                                <input type=\"hidden\" name=\"season\" ";
if(runtime.memberLookup((t_9),"season")) {
t_5 += "value=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),"season"), env.opts.autoescape);
t_5 += "\"";
;
}
t_5 += ">\n                                <input type=\"hidden\" name=\"role\" value=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),"role"), env.opts.autoescape);
t_5 += "\">\n\n                                <div class=\"MemberProfileEditCredits-body-form-inputWrapper-poster\">\n                                    <img ";
if(runtime.memberLookup((t_9),"cover")) {
t_5 += "src=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_9),"cover")),"w440_url"), env.opts.autoescape);
t_5 += "\"";
;
}
else {
if(runtime.memberLookup((t_9),"id")) {
t_5 += "src=\"";
t_5 += runtime.suppressValue((lineno = 18, colno = 109, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "static"), "static", context, ["img/no-cover.png"])), env.opts.autoescape);
t_5 += "\"";
;
}
;
}
t_5 += " alt=\"\">\n                                </div>\n                                <div class=\"MemberProfileEditCredits-body-form-inputWrapper-info\">\n                                    <div class=\"MemberProfileEditCredits-body-form-inputWrapper-infoName\">\n                                        ";
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),"title"), env.opts.autoescape);
t_5 += "\n                                    </div>\n                                    <div class=\"MemberProfileEditCredits-body-form-inputWrapper-infoSeason\">\n                                       ";
if(runtime.memberLookup((t_9),"season")) {
t_5 += "<span>&nbsp;/&nbsp;</span>";
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),"season"), env.opts.autoescape);
;
}
t_5 += "\n                                    </div>\n\n                                </div>\n                                <div class=\"MemberProfileEditCredits-body-form-inputWrapper-role\">\n                                    ";
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),"role"), env.opts.autoescape);
t_5 += "\n                                </div>\n                                <div class=\"MemberProfileEditCredits-body-form-inputIcons\">\n                                    <div class=\"MemberProfileEditCredits-body-form-inputIcons-edit\" data-id=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),"id"), env.opts.autoescape);
t_5 += "\">\n                                        <svg xmlns=\"http://www.w3.org/2000/svg\"\n                                             xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n                                             preserveAspectRatio=\"xMidYMid\" width=\"80\" height=\"80\"\n                                             viewBox=\"-2 -2 84 84\">\n                                            <path d=\"M40.923,50.543 L36.679,50.554 L31.355,47.567 L29.012,43.729 L40.892,23.003 L40.871,24.280 L42.709,27.181 L48.249,30.352 L52.265,30.335 L53.000,29.936 L40.923,50.543 ZM46.566,27.118 C45.519,26.516 44.926,25.584 45.242,25.037 C45.559,24.492 46.664,24.538 47.711,25.140 C48.758,25.743 49.351,26.675 49.035,27.221 C48.718,27.767 47.613,27.721 46.566,27.118 ZM29.331,56.994 L29.002,51.470 C30.721,53.878 33.927,54.174 33.927,54.174 L29.331,56.994 Z\" />\n                                        </svg>\n                                    </div>\n                                    <div class=\"MemberProfileEditCredits-body-form-inputIcons-drag\">\n                                        <div class=\"MemberProfileEditCredits-body-form-inputIcons-dragItem MemberProfileEditCredits-body-form-inputIcons-dragItem--top\"></div>\n                                        <div class=\"MemberProfileEditCredits-body-form-inputIcons-dragItem MemberProfileEditCredits-body-form-inputIcons-dragItem--middle\"></div>\n                                        <div class=\"MemberProfileEditCredits-body-form-inputIcons-dragItem MemberProfileEditCredits-body-form-inputIcons-dragItem--bottom\"></div>\n                                    </div>\n                                    <div class=\"MemberProfileEditCredits-body-form-inputIcons-delete\">\n                                        <div class=\"MemberProfileEditCredits-body-form-inputIcons-deleteItem MemberProfileEditCredits-body-form-inputIcons-deleteItem--top\"></div>\n                                        <div class=\"MemberProfileEditCredits-body-form-inputIcons-deleteItem MemberProfileEditCredits-body-form-inputIcons-deleteItem--bottom\"></div>\n                                    </div>\n                                </div>\n                            </div>\n                        ";
;
}
}
frame = frame.pop();
t_5 += "\n                    </form>\n                </div>\n            </div>\n        </div>\n        <div class=\"MemberProfileEditCredits-buttons\">\n            <div class=\"MemberProfileEditCredits-buttons-button MemberProfileEditCredits-buttons-button--cancel\">\n                cancel\n            </div>\n            <div class=\"MemberProfileEditCredits-buttons-button MemberProfileEditCredits-buttons-button--save\">\n                save\n            </div>\n        </div>\n\n        <div class=\"MemberProfileEditCredits-info\">\n            <div class=\"MemberProfileEditCredits-infoNote\">Need help reordering?</div>\n            <div class=\"MemberProfileEditCredits-infoIcon\">?</div>\n            <div class=\"MemberProfileEditCredits-infoPopup\">\n                <span>If you'd like to reorder your credits, simply hold and drag the hamburger icon of the credit you'd like to move up or down.</span>\n                <div class=\"MemberProfileEditCredits-infoPopupCorner\"></div>\n            </div>\n        </div>\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_5);
});
context.addExport("MemberProfileEditCredits");
context.setVariable("MemberProfileEditCredits", macro_t_4);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/MemberProfileEdit/MemberProfileEditCredits.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MemberProfileEdit/MemberProfileEditCredits.jinja
// module id = 110
// module chunks = 0